import { ActionIcon, Grid, Group, Stack, Title } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import {
  IconBrandLinkedin,
  IconMail,
  IconBrandYoutube,
  IconBrandGithub,
} from "@tabler/icons";
import { motion } from "framer-motion";

function End() {
  const { height, width } = useViewportSize();

  return (
    <Grid style={{ minHeight: height }} align="center">
      <Grid.Col span={12}>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ ease: "anticipate", delay: 0.3 }}
        >
          <Stack>
            <Title
              order={1}
              variant="gradient"
              gradient={{ from: "blue", to: "blue.4" }}
              size={50}
            >
              Thanks For Visiting! <br /> Contact Me!
            </Title>
          </Stack>
        </motion.div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ ease: "anticipate", delay: 0.5 }}
        >
          <Group position="center" py="md">
            <motion.div
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <ActionIcon
                color="blue.5"
                variant="transparent"
                size="lg"
                component="a"
                href="https://www.linkedin.com/in/raphaelgohwenxuan/"
                target="_blank"
              >
                <IconBrandLinkedin size={40} />
              </ActionIcon>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <ActionIcon
                color="blue.5"
                variant="transparent"
                size="lg"
                component="a"
                href="https://github.com/raphaelgohwx"
                target="_blank"
              >
                <IconBrandGithub size={40} />
              </ActionIcon>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <ActionIcon
                color="blue.5"
                variant="transparent"
                size="lg"
                component="a"
                href="mailto:raphaelgoh.wenxuan@gmail.com"
              >
                <IconMail size={40} />
              </ActionIcon>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.15 }}
              whileTap={{ scale: 0.9 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <ActionIcon
                color="blue.5"
                variant="transparent"
                size="lg"
                component="a"
                href="https://www.youtube.com/@raphaelgohwx"
                target="_blank"
              >
                <IconBrandYoutube size={40} />
              </ActionIcon>
            </motion.div>
          </Group>
        </motion.div>
      </Grid.Col>
    </Grid>
  );
}

export default End;
